import { Controller } from "stimulus";

import TomSelect from "tom-select";

export default class extends Controller {
  connect() {
    new TomSelect(this.element, {
      maxOptions: null,
      searchField: ["text", "code"],
      render: {
        option: (data, escape) => this.row(data, escape, "d-block"),
        item: (data, escape) => this.row(data, escape, "ms-2"),
      },
    });
  }

  row(data, escape, codeClass) {
    if (!data.code) {
      return `<div>${escape(data.text)}</div>`;
    }

    return `<div>
      <span>${escape(data.text)}</span>
      <small class="text-muted ${codeClass}">${escape(data.code)}</small>
    </div>`;
  }
}
